(function () {
  'use strict';

  var section = document.getElementById('hs-bundle-builder');
  if (!section) return;

  var packVariantsInit = {};
  try { packVariantsInit = JSON.parse(section.dataset.packVariants || '{}'); } catch (e) {}

  // Load i18n strings from Liquid-generated JSON config
  var i18n = {};
  try {
    var i18nEl = document.getElementById('hs-bundle-i18n');
    if (i18nEl) i18n = JSON.parse(i18nEl.textContent);
  } catch (e) {}

  var state = {
    selections: [],
    minItems: parseInt(section.dataset.minItems, 10) || parseInt(section.dataset.bundleSize, 10) || 3,
    maxItems: parseInt(section.dataset.maxItems, 10) || 5,
    bundleVariantId: section.dataset.bundleVariantId || '',
    bundlePrice: parseInt(section.dataset.bundlePrice, 10) || 0,
    packVariants: packVariantsInit,
    variantFilter: section.dataset.activeVariantFilter || '',
    giftEnabled: section.dataset.giftEnabled === 'true',
    giftVariantFilter: section.dataset.giftVariantFilter || '',
    giftQuantity: parseInt(section.dataset.giftQuantity, 10) || 1,
    giftHeading: section.dataset.giftHeading || (i18n.choose_gift_single || 'Choose your free gift'),
    giftSelections: []
  };

  // DOM refs
  var productList = section.querySelector('.hs-bundle__product-list');
  var slotsList = section.querySelector('.hs-bundle__slots');
  var counterEls = section.querySelectorAll('.hs-bundle__count');
  var atcButtons = document.querySelectorAll('.hs-bundle__atc');
  var searchInput = section.querySelector('.hs-bundle__search');
  var categoryDropdown = section.querySelector('[data-filter="category"]');
  var brandDropdown = section.querySelector('[data-filter="brand"]');
  var giftSection = section.querySelector('.hs-bundle__gift-section');
  var giftHeadingEl = section.querySelector('.hs-bundle__gift-heading');

  // View toggle
  var viewBtns = section.querySelectorAll('.hs-bundle__view-btn');
  var savedView = sessionStorage.getItem('bundle-view');

  if (savedView === 'grid') {
    productList.classList.add('hs-bundle__product-list--grid');
    var gridBtn = section.querySelector('[data-view="grid"]');
    var listBtn = section.querySelector('[data-view="list"]');
    if (gridBtn) gridBtn.classList.add('hs-bundle__view-btn--active');
    if (listBtn) listBtn.classList.remove('hs-bundle__view-btn--active');
  }

  viewBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var view = btn.dataset.view;
      viewBtns.forEach(function(b) { b.classList.remove('hs-bundle__view-btn--active'); });
      btn.classList.add('hs-bundle__view-btn--active');
      productList.classList.toggle('hs-bundle__product-list--grid', view === 'grid');
      sessionStorage.setItem('bundle-view', view);
    });
  });

  // Mobile drawer refs
  var mobileDrawer = document.querySelector('[data-mobile-drawer]');
  var mobileOverlay = document.querySelector('[data-drawer-overlay]');
  var mobileSlots = document.querySelector('.hs-bundle__mobile-slots');
  var drawerToggle = document.querySelector('[data-drawer-toggle]');
  var drawerClose = document.querySelector('[data-drawer-close]');

  var mobileBar = document.querySelector('.hs-bundle__mobile-bar');

  function openMobileDrawer() {
    if (mobileDrawer) mobileDrawer.classList.add('hs-bundle__mobile-drawer--open');
    if (mobileOverlay) mobileOverlay.classList.add('hs-bundle__mobile-overlay--visible');
    if (mobileBar) mobileBar.classList.add('hs-bundle__mobile-bar--drawer-open');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileDrawer() {
    if (mobileDrawer) mobileDrawer.classList.remove('hs-bundle__mobile-drawer--open');
    if (mobileOverlay) mobileOverlay.classList.remove('hs-bundle__mobile-overlay--visible');
    if (mobileBar) mobileBar.classList.remove('hs-bundle__mobile-bar--drawer-open');
    document.body.style.overflow = '';
  }

  function updateMobileSlots() {
    if (!mobileSlots) return;
    var perItem = getPerItemPrice();
    var perItemText = perItem ? (perItem / 100) + ' ' + (i18n.currency_suffix || 'SEK') : '';
    var html = '';
    state.selections.forEach(function(item) {
      for (var q = 0; q < item.qty; q++) {
        var row = productList ? productList.querySelector('.hs-bundle-row[data-variant-id="' + item.variantId + '"]') : null;
        var inspiredEl = row ? row.querySelector('.hs-bundle-row__inspired') : null;
        var inspiredText = inspiredEl ? inspiredEl.textContent : '';
        html += '<li class="hs-bundle__mobile-slot">' +
          '<div class="hs-bundle__mobile-slot-thumb"><img src="' + item.image + '" alt="' + item.title.replace(/"/g, '&quot;') + '"></div>' +
          '<div style="flex:1;min-width:0"><span class="hs-bundle__mobile-slot-name">' + item.title + '</span>' +
          (inspiredText ? '<span style="display:block;font-size:11px;color:#888;margin-top:2px">' + inspiredText + '</span>' : '') +
          '</div>' +
          (perItemText ? '<span class="hs-bundle__mobile-slot-price">' + perItemText + '</span>' : '') +
          '<button class="hs-bundle__mobile-slot-remove" data-mobile-remove="' + item.variantId + '" aria-label="' + (i18n.remove_label || 'Remove') + '">&times;</button>' +
        '</li>';
      }
    });
    if (!html) html = '<li style="padding:20px;text-align:center;color:#999;font-size:13px">' + (i18n.mobile_no_products || 'No products selected') + '</li>';
    mobileSlots.innerHTML = html;
  }

  if (drawerToggle) drawerToggle.addEventListener('click', function() {
    if (mobileDrawer && mobileDrawer.classList.contains('hs-bundle__mobile-drawer--open')) {
      closeMobileDrawer();
    } else {
      openMobileDrawer();
    }
  });
  if (drawerClose) drawerClose.addEventListener('click', closeMobileDrawer);
  if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobileDrawer);
  if (mobileSlots) {
    mobileSlots.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-mobile-remove]');
      if (!btn) return;
      var vid = btn.dataset.mobileRemove;
      var row = productList.querySelector('.hs-bundle-row[data-variant-id="' + vid + '"]');
      if (row) {
        var removeEvent = new Event('click', { bubbles: true });
        var minusBtn = row.querySelector('.hs-bundle-row__qty-minus');
        if (minusBtn) minusBtn.click();
      }
      closeMobileDrawer();
    });
  }
  var giftListEl = section.querySelector('.hs-bundle__gift-list');
  var giftSearchInput = section.querySelector('.hs-bundle__gift-search');
  var giftSlotsWrap = section.querySelector('.hs-bundle__gift-slots-wrap');
  var giftSlotsList = section.querySelector('.hs-bundle__gift-slots');
  var giftBuilt = false; // tracks whether gift HTML has been rendered

  // ---- Selection logic ----

  function getTotalQty() {
    return state.selections.reduce(function (sum, s) { return sum + s.qty; }, 0);
  }

  function findSelection(variantId) {
    for (var i = 0; i < state.selections.length; i++) {
      if (state.selections[i].variantId === variantId) return i;
    }
    return -1;
  }

  function selectPackVariant(total) {
    var packKey = String(Math.max(state.minItems, Math.min(total || state.minItems, state.maxItems)));
    if (state.packVariants[packKey]) {
      state.bundleVariantId = String(state.packVariants[packKey].id);
      state.bundlePrice = state.packVariants[packKey].price;
    }
  }

  function addToSet(rowEl) {
    var total = getTotalQty();
    if (total >= state.maxItems) return;

    var variantId = rowEl.dataset.variantId;
    var idx = findSelection(variantId);

    if (idx >= 0) {
      state.selections[idx].qty += 1;
    } else {
      state.selections.push({
        variantId: variantId,
        title: rowEl.dataset.productTitle,
        variantTitle: rowEl.dataset.variantTitle,
        price: parseInt(rowEl.dataset.price, 10) || 0,
        image: rowEl.dataset.image,
        qty: 1
      });
    }

    updateRowUI(rowEl);
    updateSidebar();
    updateDisabledState();
    updateGiftVisibility();
  }

  function removeFromSet(rowEl) {
    var variantId = rowEl.dataset.variantId;
    var idx = findSelection(variantId);
    if (idx < 0) return;

    state.selections[idx].qty -= 1;
    if (state.selections[idx].qty <= 0) {
      state.selections.splice(idx, 1);
    }

    updateRowUI(rowEl);
    updateSidebar();
    updateDisabledState();
    updateGiftVisibility();
  }

  // ---- Row UI ----

  function updateRowUI(rowEl) {
    var variantId = rowEl.dataset.variantId;
    var idx = findSelection(variantId);
    var addBtn = rowEl.querySelector('.hs-bundle-row__add-btn');
    var qtyWrap = rowEl.querySelector('.hs-bundle-row__qty');
    var qtyValue = rowEl.querySelector('.hs-bundle-row__qty-value');

    if (idx >= 0 && state.selections[idx].qty > 0) {
      addBtn.style.display = 'none';
      qtyWrap.style.display = 'flex';
      qtyValue.textContent = state.selections[idx].qty;
      rowEl.classList.add('hs-bundle-row--selected');
    } else {
      addBtn.style.display = '';
      qtyWrap.style.display = 'none';
      qtyValue.textContent = '0';
      rowEl.classList.remove('hs-bundle-row--selected');
    }
  }

  function updateDisabledState() {
    var total = getTotalQty();
    var isFull = total >= state.maxItems;

    var rows = productList.querySelectorAll('.hs-bundle-row');
    rows.forEach(function (row) {
      var isSelected = row.classList.contains('hs-bundle-row--selected');
      var plusBtn = row.querySelector('.hs-bundle-row__qty-plus');

      if (isFull && !isSelected) {
        row.classList.add('hs-bundle-row--disabled');
      } else {
        row.classList.remove('hs-bundle-row--disabled');
      }

      if (plusBtn) {
        plusBtn.disabled = isFull;
      }
    });
  }

  // ---- Gift logic ----

  function buildGiftList() {
    if (!giftSection || !giftListEl) return;
    giftBuilt = false;

    if (!state.giftEnabled || !state.giftVariantFilter) {
      giftSection.hidden = true;
      if (giftSlotsWrap) giftSlotsWrap.hidden = true;
      return;
    }

    giftHeadingEl.textContent = state.giftHeading;

    // Collect gift-eligible products
    var rows = productList.querySelectorAll('.hs-bundle-row');
    var giftItems = [];

    rows.forEach(function (row) {
      var variants;
      try {
        variants = JSON.parse(row.dataset.variants || '[]');
      } catch (e) {
        variants = [];
      }

      var matched = null;
      for (var i = 0; i < variants.length; i++) {
        if (handleize(variants[i].title) === state.giftVariantFilter && variants[i].available) {
          matched = variants[i];
          break;
        }
      }

      if (!matched) return;

      var isBestseller = !!row.querySelector('.hs-bundle-row__tag--bestseller');
      var inspiredEl = row.querySelector('.hs-bundle-row__inspired');
      var gender = row.dataset.gender || '';
      giftItems.push({
        variantId: String(matched.id),
        title: row.dataset.productTitle || '',
        image: matched.image || row.dataset.image || '',
        bestseller: isBestseller,
        inspired: inspiredEl ? inspiredEl.textContent.trim() : '',
        gender: gender,
        search: (row.dataset.search || '').toLowerCase()
      });
    });

    // Sort: bestsellers first, then alphabetical
    giftItems.sort(function (a, b) {
      if (a.bestseller && !b.bestseller) return -1;
      if (!a.bestseller && b.bestseller) return 1;
      return a.title.localeCompare(b.title);
    });

    // Render gift rows
    var html = '';
    giftItems.forEach(function (item) {
      var thumbSrc = item.image ? item.image.replace('width=800', 'width=120') : '';
      var escapedTitle = item.title.replace(/"/g, '&quot;');

      // Gender label
      var genderLabel = '';
      if (item.gender === 'him') genderLabel = i18n.badge_him || 'Him';
      else if (item.gender === 'her') genderLabel = i18n.badge_her || 'Her';
      else if (item.gender === 'unisex') genderLabel = i18n.badge_unisex || 'Unisex';

      // Build tags
      var tagsHtml = '';
      if (item.bestseller) tagsHtml += '<span class="hs-gift-row__tag hs-gift-row__tag--bestseller">' + (i18n.badge_bestseller || 'Bestseller') + '</span>';
      if (genderLabel) tagsHtml += '<span class="hs-gift-row__tag hs-gift-row__tag--gender">' + genderLabel + '</span>';

      html +=
        '<div class="hs-gift-row" data-gift-variant-id="' + item.variantId + '" data-gift-title="' + escapedTitle + '" data-gift-image="' + item.image.replace(/"/g, '&quot;') + '" data-gift-search="' + item.search.replace(/"/g, '&quot;') + '">' +
          '<div class="hs-gift-row__thumb">' +
            (thumbSrc ? '<img src="' + thumbSrc + '" alt="' + escapedTitle + '" loading="lazy">' : '<div class="hs-gift-row__thumb-placeholder"></div>') +
          '</div>' +
          '<div class="hs-gift-row__info">' +
            '<div class="hs-gift-row__top">' +
              '<span class="hs-gift-row__name">' + item.title + '</span>' +
              (item.inspired ? '<span class="hs-gift-row__inspired">' + item.inspired + '</span>' : '') +
            '</div>' +
            (tagsHtml ? '<div class="hs-gift-row__tags">' + tagsHtml + '</div>' : '') +
          '</div>' +
          '<button class="hs-gift-row__select-btn" aria-label="' + (i18n.choose_gift_single || 'Choose') + '">' +
            '<svg class="hs-gift-row__icon-plus" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M8 3v10M3 8h10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>' +
            '<svg class="hs-gift-row__icon-check" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M3 8.5L6.5 12L13 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
          '</button>' +
        '</div>';
    });

    giftListEl.innerHTML = html;
    giftBuilt = giftItems.length > 0;

    // Clear search
    if (giftSearchInput) giftSearchInput.value = '';

    // Keep hidden — updateGiftVisibility will show when bundle is full
    giftSection.hidden = true;
    if (giftSlotsWrap) giftSlotsWrap.hidden = true;

    updateGiftRowsUI();
    updateGiftSlots();
  }

  // Show/hide gift section based on main bundle completeness
  var giftWasVisible = false;

  function updateGiftVisibility() {
    if (!giftSection || !giftBuilt) return;

    var total = getTotalQty();
    var minReached = total >= state.minItems;

    if (state.giftEnabled && minReached) {
      if (giftSection.hidden) {
        giftSection.hidden = false;
        if (giftSlotsWrap) giftSlotsWrap.hidden = false;

        // Auto-scroll to gift section on first reveal
        if (!giftWasVisible) {
          giftWasVisible = true;
          setTimeout(function () {
            giftSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }, 100);
        }
      }
    } else {
      giftSection.hidden = true;
      if (giftSlotsWrap) giftSlotsWrap.hidden = true;
    }
  }

  function applyGiftSearch() {
    if (!giftListEl || !giftSearchInput) return;
    var term = giftSearchInput.value.toLowerCase().trim();
    var rows = giftListEl.querySelectorAll('.hs-gift-row');
    rows.forEach(function (row) {
      if (!term || (row.dataset.giftSearch || '').indexOf(term) !== -1) {
        row.style.display = '';
      } else {
        row.style.display = 'none';
      }
    });
  }

  function selectGift(giftRow) {
    var variantId = giftRow.dataset.giftVariantId;
    var idx = -1;
    for (var i = 0; i < state.giftSelections.length; i++) {
      if (state.giftSelections[i].variantId === variantId) { idx = i; break; }
    }

    if (idx >= 0) {
      // Deselect
      state.giftSelections.splice(idx, 1);
    } else {
      // Select — if at max, replace oldest
      if (state.giftSelections.length >= state.giftQuantity) {
        state.giftSelections.shift();
      }
      state.giftSelections.push({
        variantId: variantId,
        title: giftRow.dataset.giftTitle,
        image: giftRow.dataset.giftImage
      });
    }

    updateGiftRowsUI();
    updateGiftSlots();
    updateSidebar();
  }

  function updateGiftRowsUI() {
    if (!giftListEl) return;
    var rows = giftListEl.querySelectorAll('.hs-gift-row');
    rows.forEach(function (row) {
      var vid = row.dataset.giftVariantId;
      var isSelected = false;
      for (var i = 0; i < state.giftSelections.length; i++) {
        if (state.giftSelections[i].variantId === vid) { isSelected = true; break; }
      }
      if (isSelected) {
        row.classList.add('hs-gift-row--selected');
      } else {
        row.classList.remove('hs-gift-row--selected');
      }
    });
  }

  function updateGiftSlots() {
    if (!giftSlotsList) return;
    var html = '';
    for (var i = 0; i < state.giftQuantity; i++) {
      var gift = state.giftSelections[i];
      if (gift) {
        var thumbSrc = gift.image ? gift.image.replace('width=800', 'width=120') : '';
        html +=
          '<li class="hs-bundle__slot hs-bundle__slot--gift hs-bundle__slot--filled">' +
            '<div class="hs-bundle__slot-filled">' +
              (thumbSrc ? '<img class="hs-bundle__slot-img" src="' + thumbSrc + '" alt="' + gift.title.replace(/"/g, '&quot;') + '">' : '') +
              '<span class="hs-bundle__slot-title">' + gift.title + '</span>' +
              '<button class="hs-bundle__gift-slot-remove" data-gift-variant-id="' + gift.variantId + '" aria-label="' + (i18n.remove_label || 'Remove') + '">&times;</button>' +
            '</div>' +
          '</li>';
      } else {
        html +=
          '<li class="hs-bundle__slot hs-bundle__slot--gift">' +
            '<span class="hs-bundle__slot-placeholder">' + (i18n.gift_slot_placeholder || 'Choose gift') + '</span>' +
          '</li>';
      }
    }
    giftSlotsList.innerHTML = html;
  }

  function isGiftComplete() {
    return !state.giftEnabled || state.giftSelections.length >= state.giftQuantity;
  }

  // ---- Sidebar ----

  function ensureSlotCount(needed) {
    var slots = slotsList.querySelectorAll('.hs-bundle__slot');
    // Add slots if needed
    while (slots.length < needed) {
      var li = document.createElement('li');
      li.className = 'hs-bundle__slot';
      li.dataset.slot = slots.length + 1;
      li.innerHTML = '<div class="hs-bundle__slot-thumb"></div><span class="hs-bundle__slot-placeholder">' + (i18n.slot_placeholder || 'Choose product') + '</span>';
      slotsList.appendChild(li);
      slots = slotsList.querySelectorAll('.hs-bundle__slot');
    }
    // Remove empty excess slots (never remove filled ones)
    while (slots.length > needed) {
      var last = slots[slots.length - 1];
      if (last.classList.contains('hs-bundle__slot--filled')) break;
      slotsList.removeChild(last);
      slots = slotsList.querySelectorAll('.hs-bundle__slot');
    }
  }

  function updateSidebar() {
    var total = getTotalQty();

    // Select correct pack variant based on item count
    selectPackVariant(total);

    var minReached = total >= state.minItems;

    // Dynamic slot count: show at least minItems slots, expand as items are added
    var slotsNeeded = Math.max(state.minItems, total + (total < state.maxItems ? 1 : 0));
    slotsNeeded = Math.min(slotsNeeded, state.maxItems);
    ensureSlotCount(slotsNeeded);

    counterEls.forEach(function (el) {
      el.textContent = total;
    });

    // Update total display — always show minItems as denominator
    var totalEls = section.querySelectorAll('.hs-bundle__total');
    totalEls.forEach(function (el) {
      el.textContent = state.minItems;
    });

    var slots = slotsList.querySelectorAll('.hs-bundle__slot');
    var slotIndex = 0;
    var perItem = getPerItemPrice();
    var perItemText = perItem ? (perItem / 100) + ' ' + (i18n.currency_suffix || 'SEK') : '';

    state.selections.forEach(function (item) {
      for (var q = 0; q < item.qty; q++) {
        if (slotIndex < slots.length) {
          var row = productList ? productList.querySelector('.hs-bundle-row[data-variant-id="' + item.variantId + '"]') : null;
          var inspiredEl = row ? row.querySelector('.hs-bundle-row__inspired') : null;
          var inspiredText = inspiredEl ? inspiredEl.textContent : '';

          slots[slotIndex].innerHTML =
            '<button class="hs-bundle__slot-remove" data-variant-id="' + item.variantId + '" aria-label="' + (i18n.remove_label || 'Remove') + '">&times;</button>' +
            '<div class="hs-bundle__slot-thumb"><img src="' + item.image + '" alt="' + item.title.replace(/"/g, '&quot;') + '"></div>' +
            '<div class="hs-bundle__slot-info">' +
              '<span class="hs-bundle__slot-name">' + item.title + '</span>' +
              (inspiredText ? '<span class="hs-bundle__slot-subtitle">' + inspiredText + '</span>' : '') +
            '</div>' +
            (perItemText ? '<span class="hs-bundle__slot-price">' + perItemText + '</span>' : '');
          slots[slotIndex].classList.add('hs-bundle__slot--filled');
          slotIndex++;
        }
      }
    });

    for (var i = slotIndex; i < slots.length; i++) {
      slots[i].innerHTML = '<div class="hs-bundle__slot-thumb"></div><span class="hs-bundle__slot-placeholder">' + (i18n.slot_placeholder || 'Choose product') + '</span>';
      slots[i].classList.remove('hs-bundle__slot--filled');
    }

    // Dynamic pricing from pack variants
    var priceEl = section.querySelector('.hs-bundle__price');
    if (priceEl) {
      var _cur = ' ' + (i18n.currency_suffix || 'SEK');
      var priceText = (state.bundlePrice / 100) + _cur;
      if (total > state.minItems) {
        var basePrice = state.packVariants[String(state.minItems)] ? state.packVariants[String(state.minItems)].price : state.bundlePrice;
        var extraCost = state.bundlePrice - basePrice;
        if (extraCost > 0) {
          priceText += ' <span class="hs-bundle__price-extra">(+' + (total - state.minItems) + ' extra: ' + (extraCost / 100) + _cur + ')</span>';
        }
      }
      priceEl.innerHTML = priceText;
    }
    var _cur = ' ' + (i18n.currency_suffix || 'SEK');
    var mobilePriceEl = section.querySelector('.hs-bundle__mobile-price');
    if (mobilePriceEl) {
      mobilePriceEl.textContent = (state.bundlePrice / 100) + _cur;
    }
    var mobileAtcPrice = section.querySelector('.hs-bundle__mobile-atc-price');
    if (mobileAtcPrice) {
      mobileAtcPrice.textContent = (state.bundlePrice / 100) + _cur;
    }

    var giftDone = isGiftComplete();
    var canSubmit = minReached && giftDone;

    var priceFormatted = (state.bundlePrice / 100) + _cur;

    atcButtons.forEach(function (btn) {
      btn.disabled = !canSubmit;
      var textEl = btn.querySelector('.hs-bundle__atc-text');
      if (textEl) {
        if (!minReached) {
          var countText = (i18n.products_count || '_COUNT_/_TOTAL_ PRODUCTS').replace('_COUNT_', total).replace('_TOTAL_', state.minItems);
          textEl.textContent = countText;
        } else if (state.giftEnabled && !giftDone) {
          var giftRemaining = state.giftQuantity - state.giftSelections.length;
          if (giftRemaining === 1) {
            textEl.textContent = i18n.choose_gift_single || 'Choose your free gift';
          } else {
            textEl.textContent = (i18n.choose_gift_plural || 'Choose _COUNT_ gifts').replace('_COUNT_', giftRemaining);
          }
        } else {
          textEl.textContent = (i18n.add_to_cart || 'ADD TO CART – _PRICE_').replace('_PRICE_', priceFormatted);
        }
      }
    });

    // Update savings text
    var savingsEl = section.querySelector('.hs-bundle__savings');
    if (savingsEl) {
      if (minReached) {
        savingsEl.textContent = '';
      } else {
        savingsEl.textContent = (i18n.select_min_products || 'Select at least _COUNT_ products').replace('_COUNT_', state.minItems);
      }
    }

    updatePerItemPrices();
    updateMobileSlots();
  }

  // ---- Filtering: search + dropdowns ----

  function applyFilters() {
    var searchTerm = (searchInput ? searchInput.value : '').toLowerCase().trim();
    var categoryVal = categoryDropdown ? categoryDropdown.value : 'all';
    var brandVal = brandDropdown ? brandDropdown.value : 'all';

    var rows = productList.querySelectorAll('.hs-bundle-row');
    rows.forEach(function (row) {
      var matchSearch = true;
      var matchCategory = true;
      var matchBrand = true;

      // Search filter
      if (searchTerm) {
        var searchData = (row.dataset.search || '').toLowerCase();
        matchSearch = searchData.indexOf(searchTerm) !== -1;
      }

      // Category filter
      if (categoryVal !== 'all') {
        matchCategory = row.dataset.gender === categoryVal;
      }

      // Brand filter
      if (brandVal !== 'all') {
        matchBrand = row.dataset.brand === brandVal;
      }

      // Don't un-hide rows hidden by variant size filter
      if (row.classList.contains('hs-bundle-row--hidden-by-size')) {
        row.classList.remove('hs-bundle-row--hidden');
        return;
      }

      if (matchSearch && matchCategory && matchBrand) {
        row.classList.remove('hs-bundle-row--hidden');
      } else {
        row.classList.add('hs-bundle-row--hidden');
      }
    });
  }

  // ---- Variant size filtering ----

  function handleize(str) {
    return str.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
  }

  function applyVariantFilter(filterSize) {
    state.variantFilter = filterSize || '';
    section.dataset.activeVariantFilter = state.variantFilter;

    var rows = productList.querySelectorAll('.hs-bundle-row');
    rows.forEach(function (row) {
      if (!state.variantFilter) {
        row.classList.remove('hs-bundle-row--hidden-by-size');
        return;
      }

      var variants;
      try {
        variants = JSON.parse(row.dataset.variants || '[]');
      } catch (e) {
        variants = [];
      }

      var matched = null;
      for (var i = 0; i < variants.length; i++) {
        if (handleize(variants[i].title) === state.variantFilter && variants[i].available) {
          matched = variants[i];
          break;
        }
      }

      if (matched) {
        // Update row to use this variant
        row.dataset.variantId = String(matched.id);
        row.dataset.variantTitle = matched.title;
        row.dataset.price = String(matched.price);
        row.dataset.image = matched.image;

        // Update thumbnail image
        var thumbImg = row.querySelector('.hs-bundle-row__thumb img');
        if (thumbImg) {
          thumbImg.src = matched.image;
        }

        // Per-item price is updated by updatePerItemPrices()


        row.classList.remove('hs-bundle-row--hidden-by-size');
      } else {
        row.classList.add('hs-bundle-row--hidden-by-size');
      }
    });
  }

  // ---- Cart submission ----

  async function submitBundle() {
    var total = getTotalQty();
    if (total < state.minItems) return;

    atcButtons.forEach(function (btn) {
      btn.disabled = true;
      var textEl = btn.querySelector('.hs-bundle__atc-text');
      if (textEl) textEl.textContent = i18n.adding_to_cart || 'Adding...';
    });

    var properties = {};
    var index = 1;
    var productTypeData = [];

    // Format: "Perfume 1 (100 ML) X 1": "Vanguard" (or localized equivalent)
    // Matches the format the DO server app expects
    // Include ALL items (base + extras) in properties
    var perfumeTpl = (i18n.perfume_property || 'Perfume _INDEX_ (_SIZE_) X 1');
    state.selections.forEach(function (item) {
      for (var i = 0; i < item.qty; i++) {
        var key = perfumeTpl.replace('_INDEX_', index).replace('_SIZE_', item.variantTitle);
        properties[key] = item.title;
        index++;
      }
      productTypeData.push({
        id: item.variantId,
        qty: item.qty,
        name: item.title
      });
    });

    // Add gift to productTypeData + visible properties
    // Gift variants go into __product_type so the DO server
    // adds them to the order with 100% discount automatically
    if (state.giftEnabled && state.giftSelections.length > 0) {
      var giftTpl = (i18n.gift_property || 'Free gift _INDEX_ (_SIZE_) X 1');
      state.giftSelections.forEach(function (gift, gi) {
        var giftKey = giftTpl.replace('_INDEX_', gi + 1).replace('_SIZE_', state.giftVariantFilter.replace(/-/g, ' ').toUpperCase());
        properties[giftKey] = gift.title;
        productTypeData.push({
          id: gift.variantId,
          qty: 1,
          name: gift.title
        });
      });
    }

    properties['__product_type'] = JSON.stringify(productTypeData);

    // Get the cart drawer section ID so Shopify returns updated HTML
    var cartItemsEl = document.querySelector('cart-items-component');
    var cartSectionId = cartItemsEl ? cartItemsEl.dataset.sectionId : '';

    var cartAddUrl = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add';

    var formData = new FormData();
    formData.append('id', state.bundleVariantId);
    formData.append('quantity', '1');
    if (cartSectionId) {
      formData.append('sections', cartSectionId);
    }
    Object.keys(properties).forEach(function (key) {
      formData.append('properties[' + key + ']', properties[key]);
    });

    try {
      var response = await fetch(cartAddUrl + '.js', {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json'
        },
        body: formData
      });

      if (!response.ok) {
        throw new Error('Cart add failed: ' + response.status);
      }

      var data = await response.json();
      var sections = (data && data.sections) ? data.sections : {};

      // Dispatch cart:update with sections — this is what the theme expects
      // cart-items-component uses sections to morph the drawer content
      // cart-drawer-component opens the drawer
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: data,
          sourceId: state.bundleVariantId,
          data: {
            source: 'bundle-builder',
            itemCount: 1,
            productId: null,
            sections: sections
          }
        }
      }));

      resetBundle();
    } catch (err) {
      console.error('Bundle submission error:', err);
      atcButtons.forEach(function (btn) {
        btn.disabled = false;
        var textEl = btn.querySelector('.hs-bundle__atc-text');
        if (textEl) textEl.textContent = i18n.try_again || 'Try again';
      });
    }
  }

  function resetBundle() {
    state.selections = [];
    state.giftSelections = [];
    giftWasVisible = false;

    var rows = productList.querySelectorAll('.hs-bundle-row');
    rows.forEach(function (row) {
      updateRowUI(row);
      row.classList.remove('hs-bundle-row--disabled');
    });

    updateGiftRowsUI();
    updateGiftSlots();
    updateSidebar();
    updateDisabledState();
    updateGiftVisibility();
  }

  // ---- Bundle option switching ----

  function rebuildSlots() {
    var html = '';
    for (var i = 1; i <= state.minItems; i++) {
      html += '<li class="hs-bundle__slot" data-slot="' + i + '">' +
        '<div class="hs-bundle__slot-thumb"></div><span class="hs-bundle__slot-placeholder">' + (i18n.slot_placeholder || 'Choose product') + '</span></li>';
    }
    slotsList.innerHTML = html;
  }

  function getPerItemPrice() {
    var keys = Object.keys(state.packVariants).map(Number).sort(function (a, b) { return a - b; });
    if (keys.length >= 2) {
      // Marginal price = difference between consecutive variants
      return state.packVariants[String(keys[1])].price - state.packVariants[String(keys[0])].price;
    }
    if (keys.length === 1) {
      return Math.round(state.packVariants[String(keys[0])].price / keys[0]);
    }
    return 0;
  }

  function updatePerItemPrices() {
    // no-op — prices shown inline in slots
  }

  function switchBundle(btn) {
    var newMinSize = parseInt(btn.dataset.bundleSize, 10) || 3;
    var newMaxSize = parseInt(section.dataset.maxItems, 10) || 5;
    var newVariantId = btn.dataset.variantId || '';
    var newPrice = parseInt(btn.dataset.bundlePrice, 10) || 0;

    // Parse pack variants from button
    var newPackVariants = {};
    try { newPackVariants = JSON.parse(btn.dataset.packVariants || '{}'); } catch (e) {}

    // Update active tab
    var allBtns = section.querySelectorAll('[data-bundle-option]');
    allBtns.forEach(function (b) {
      b.classList.remove('hs-bundle__option-btn--active');
      b.setAttribute('aria-selected', 'false');
    });
    btn.classList.add('hs-bundle__option-btn--active');
    btn.setAttribute('aria-selected', 'true');

    // Update state
    state.minItems = newMinSize;
    state.maxItems = newMaxSize;
    state.bundleVariantId = newVariantId;
    state.bundlePrice = newPrice;
    state.packVariants = newPackVariants;

    // Update data attributes on section
    section.dataset.bundleSize = newMinSize;
    section.dataset.minItems = newMinSize;
    section.dataset.bundleVariantId = newVariantId;
    section.dataset.bundlePrice = newPrice;

    // Update total displays
    var totalEls = section.querySelectorAll('.hs-bundle__total');
    totalEls.forEach(function (el) { el.textContent = newMinSize; });

    // Update price display
    var _cur = ' ' + (i18n.currency_suffix || 'SEK');
    var priceEl = section.querySelector('.hs-bundle__price');
    if (priceEl) {
      priceEl.textContent = (newPrice / 100) + _cur;
    }
    var mobilePriceEl = section.querySelector('.hs-bundle__mobile-price');
    if (mobilePriceEl) {
      mobilePriceEl.textContent = (newPrice / 100) + _cur;
    }
    var mobileAtcPrice = section.querySelector('.hs-bundle__mobile-atc-price');
    if (mobileAtcPrice) {
      mobileAtcPrice.textContent = (newPrice / 100) + _cur;
    }

    // Update ATC variant IDs
    atcButtons.forEach(function (b) {
      b.dataset.bundleVariantId = newVariantId;
    });

    // Apply variant size filter
    var newFilter = btn.dataset.variantFilter || '';
    applyVariantFilter(newFilter);

    // Update per-item prices
    updatePerItemPrices();

    // Update gift state from button data
    state.giftEnabled = btn.dataset.giftEnabled === 'true';
    state.giftVariantFilter = btn.dataset.giftVariantFilter || '';
    state.giftQuantity = parseInt(btn.dataset.giftQuantity, 10) || 1;
    state.giftHeading = btn.dataset.giftHeading || (i18n.choose_gift_single || 'Choose your free gift');

    // Reset selections and rebuild sidebar slots
    resetBundle();
    rebuildSlots();
    buildGiftList();
    updateSidebar();
  }

  var optionButtons = section.querySelectorAll('[data-bundle-option]');
  optionButtons.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      switchBundle(btn);
    });
  });

  // ---- Event listeners ----

  // Product list click delegation
  productList.addEventListener('click', function (e) {
    var addBtn = e.target.closest('.hs-bundle-row__add-btn');
    if (addBtn) {
      e.preventDefault();
      var row = addBtn.closest('.hs-bundle-row');
      if (row && !row.classList.contains('hs-bundle-row--disabled')) {
        addToSet(row);
      }
      return;
    }

    var plusBtn = e.target.closest('.hs-bundle-row__qty-plus');
    if (plusBtn) {
      e.preventDefault();
      var row = plusBtn.closest('.hs-bundle-row');
      if (row) addToSet(row);
      return;
    }

    var minusBtn = e.target.closest('.hs-bundle-row__qty-minus');
    if (minusBtn) {
      e.preventDefault();
      var row = minusBtn.closest('.hs-bundle-row');
      if (row) removeFromSet(row);
      return;
    }
  });

  // Sidebar slot remove
  if (slotsList) {
    slotsList.addEventListener('click', function (e) {
      var removeBtn = e.target.closest('.hs-bundle__slot-remove');
      if (!removeBtn) return;
      e.preventDefault();

      var variantId = removeBtn.dataset.variantId;
      var row = productList.querySelector('.hs-bundle-row[data-variant-id="' + variantId + '"]');

      if (row) {
        removeFromSet(row);
      } else {
        var idx = findSelection(variantId);
        if (idx >= 0) {
          state.selections[idx].qty -= 1;
          if (state.selections[idx].qty <= 0) {
            state.selections.splice(idx, 1);
          }
          updateSidebar();
          updateDisabledState();
          updateGiftVisibility();
        }
      }
    });
  }

  // Gift list click delegation
  if (giftListEl) {
    giftListEl.addEventListener('click', function (e) {
      var selectBtn = e.target.closest('.hs-gift-row__select-btn');
      if (selectBtn) {
        e.preventDefault();
        var giftRow = selectBtn.closest('.hs-gift-row');
        if (giftRow) selectGift(giftRow);
        return;
      }
      // Also allow clicking the whole row
      var row = e.target.closest('.hs-gift-row');
      if (row) {
        e.preventDefault();
        selectGift(row);
      }
    });
  }

  // Gift search
  if (giftSearchInput) {
    var giftSearchTimer;
    giftSearchInput.addEventListener('input', function () {
      clearTimeout(giftSearchTimer);
      giftSearchTimer = setTimeout(applyGiftSearch, 150);
    });
  }

  // Gift slot remove
  if (giftSlotsList) {
    giftSlotsList.addEventListener('click', function (e) {
      var removeBtn = e.target.closest('.hs-bundle__gift-slot-remove');
      if (!removeBtn) return;
      e.preventDefault();
      var variantId = removeBtn.dataset.giftVariantId;
      for (var i = 0; i < state.giftSelections.length; i++) {
        if (state.giftSelections[i].variantId === variantId) {
          state.giftSelections.splice(i, 1);
          break;
        }
      }
      updateGiftRowsUI();
      updateGiftSlots();
      updateSidebar();
    });
  }

  // Search input
  if (searchInput) {
    var searchTimer;
    searchInput.addEventListener('input', function () {
      clearTimeout(searchTimer);
      searchTimer = setTimeout(applyFilters, 150);
    });
  }

  // Dropdown filters
  if (categoryDropdown) {
    categoryDropdown.addEventListener('change', applyFilters);
  }
  if (brandDropdown) {
    brandDropdown.addEventListener('change', applyFilters);
  }

  // ATC buttons
  atcButtons.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (!btn.disabled) {
        submitBundle();
      }
    });
  });

  // Sort product list: bestsellers first, then alphabetical
  function sortProductList() {
    var rows = Array.prototype.slice.call(productList.querySelectorAll('.hs-bundle-row'));
    rows.sort(function (a, b) {
      var aBs = !!a.querySelector('.hs-bundle-row__tag--bestseller');
      var bBs = !!b.querySelector('.hs-bundle-row__tag--bestseller');
      if (aBs && !bBs) return -1;
      if (!aBs && bBs) return 1;
      var aName = (a.dataset.productTitle || '').toLowerCase();
      var bName = (b.dataset.productTitle || '').toLowerCase();
      return aName.localeCompare(bName);
    });
    rows.forEach(function (row) {
      productList.appendChild(row);
    });
  }

  // Initialize
  sortProductList();
  if (state.variantFilter) {
    applyVariantFilter(state.variantFilter);
  }
  buildGiftList();
  updateSidebar();
  updatePerItemPrices();
})();
